
export const GET_INNOVATE_CHALLENGE_ALL_LIST_STARTED = 'GET_INNOVATE_CHALLENGE_ALL_LIST_STARTED'
export const GET_INNOVATE_CHALLENGE_ALL_LIST_FAILURE = 'GET_INNOVATE_CHALLENGE_ALL_LIST_FAILURE'
export const GET_INNOVATE_CHALLENGE_ALL_LIST_SUCCESS = 'GET_INNOVATE_CHALLENGE_ALL_LIST_SUCCESS'

export const GET_INNOVATE_CHALLENGE_FILTER_LIST_STARTED = 'GET_INNOVATE_CHALLENGE_FILTER_LIST_STARTED'
export const GET_INNOVATE_CHALLENGE_FILTER_LIST_FAILURE = 'GET_INNOVATE_CHALLENGE_FILTER_LIST_FAILURE'
export const GET_INNOVATE_CHALLENGE_FILTER_LIST_SUCCESS = 'GET_INNOVATE_CHALLENGE_FILTER_LIST_SUCCESS'

export const POST_INNOVATE_CHALLENGE_CREATE_STARTED = 'POST_INNOVATE_CHALLENGE_CREATE_STARTED'
export const POST_INNOVATE_CHALLENGE_CREATE_FAILURE = 'POST_INNOVATE_CHALLENGE_CREATE_FAILURE'
export const POST_INNOVATE_CHALLENGE_CREATE_SUCCESS = 'POST_INNOVATE_CHALLENGE_CREATE_SUCCESS'

export const POST_INNOVATE_CHALLENGE_DRAFT_STARTED = 'POST_INNOVATE_CHALLENGE_DRAFT_STARTED'
export const POST_INNOVATE_CHALLENGE_DRAFT_FAILURE = 'POST_INNOVATE_CHALLENGE_DRAFT_FAILURE'
export const POST_INNOVATE_CHALLENGE_DRAFT_SUCCESS = 'POST_INNOVATE_CHALLENGE_DRAFT_SUCCESS'

export const PUT_INNOVATE_CHALLENGE_EDIT_STARTED = 'PUT_INNOVATE_CHALLENGE_EDIT_STARTED'
export const PUT_INNOVATE_CHALLENGE_EDIT_FAILURE = 'PUT_INNOVATE_CHALLENGE_EDIT_FAILURE'
export const PUT_INNOVATE_CHALLENGE_EDIT_SUCCESS = 'PUT_INNOVATE_CHALLENGE_EDIT_SUCCESS'

export const GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_STARTED = 'GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_STARTED'
export const GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_SUCCESS = 'GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_SUCCESS'
export const GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_FAILURE = 'GET_INNOVATE_CHALLENGE_ACTIVE_TYPES_FAILURE'

export const GET_CHALLENGEINTOINNOVATE_DRAFT_STARTED = 'GET_CHALLENGEINTOINNOVATE_DRAFT_STARTED'
export const GET_CHALLENGEINTOINNOVATE_DRAFT_SUCCESS = 'GET_CHALLENGEINTOINNOVATE_DRAFT_SUCCESS'
export const GET_CHALLENGEINTOINNOVATE_DRAFT_FAILURE = 'GET_CHALLENGEINTOINNOVATE_DRAFT_FAILURE'

export const ADD_CHALLENGEDRAFT_ID_IMAGE_STARTED = 'ADD_CHALLENGEDRAFT_ID_IMAGE_STARTED'
export const ADD_CHALLENGEDRAFT_ID_IMAGE_SUCCESS = 'ADD_CHALLENGEDRAFT_ID_IMAGE_SUCCESS'
export const ADD_CHALLENGEDRAFT_ID_IMAGE_FAILURE = 'ADD_CHALLENGEDRAFT_ID_IMAGE_FAILURE'


export const GET_INNOVATE_CHALLENGE_STARTED = 'GET_INNOVATE_CHALLENGE_STARTED'
export const GET_INNOVATE_CHALLENGE_SUCCESS = 'GET_INNOVATE_CHALLENGE_SUCCESS'
export const GET_INNOVATE_CHALLENGE_FAILURE = 'GET_INNOVATE_CHALLENGE_FAILURE'

export const DELETE_CHALLENGEDRAFT_ID_IMAGE_STARTED = 'DELETE_CHALLENGEDRAFT_ID_IMAGE_STARTED'
export const DELETE_CHALLENGEDRAFT_ID_IMAGE_SUCCESS = 'DELETE_CHALLENGEDRAFT_ID_IMAGE_SUCCESS'
export const DELETE_CHALLENGEDRAFT_ID_IMAGE_FAILURE = 'DELETE_CHALLENGEDRAFT_ID_IMAGE_FAILURE'

export const POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_STARTED = 'POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_STARTED'
export const POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_SUCCESS = 'POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_SUCCESS'
export const POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_FAILURE = 'POST_CHALLENGE_INNOVATE_REMOVE_EVALUTOR_FAILURE'

export const GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_STARTED = 'GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_STARTED'
export const GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_SUCCESS = 'GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_SUCCESS'
export const GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_FAILURE = 'GET_INNOVATE_CHALLENGE_LIST_REMOVE_EVALUATOR_FAILURE'

export const GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_STARTED = 'GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_STARTED'
export const GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_SUCCESS = 'GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_SUCCESS'
export const GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_FAILURE = 'GET_INNOVATE_CHALLENGE_TAGGED_IDEA_LIST_REMOVE_EVALUATOR_FAILURE'

export const POST_INNOVATE_SPECIFIC_IDEA_LIST_FROM_CHALLENGE_REMOVE_EVALUATOR_STARTED = 'POST_INNOVATE_SPECIFIC_IDEA_LIST_FROM_CHALLENGE_REMOVE_EVALUATOR_STARTED'
export const POST_INNOVATE_SPECIFIC_IDEA_LIST_FROM_CHALLENGE_REMOVE_EVALUATOR_SUCCESS = 'POST_INNOVATE_SPECIFIC_IDEA_LIST_FROM_CHALLENGE_REMOVE_EVALUATOR_SUCCESS'
export const POST_INNOVATE_SPECIFIC_IDEA_LIST_FROM_CHALLENGE_REMOVE_EVALUATOR_FAILURE = 'POST_INNOVATE_SPECIFIC_IDEA_LIST_FROM_CHALLENGE_REMOVE_EVALUATOR_FAILURE'